import { format } from 'date-fns';
import { useParams } from 'react-router-dom';
import { IBBlank } from 'src/components/common/IBBlank';
import { Typography } from 'src/components/common/Typography';
import { useInterviewQNA } from 'src/container/ib-student-interview';

export default function CASInterviewPreview() {
  const { qnaId: qnaIdParam } = useParams<{ qnaId: string }>();
  const qnaId = Number(qnaIdParam);
  const { data: interview, isLoading } = useInterviewQNA(qnaId);

  if (interview === undefined) {
    return <IBBlank />;
  }

  return (
    <div className="flex h-screen flex-col overflow-y-auto p-8">
      {isLoading && <IBBlank />}
      <div className="flex flex-col items-start gap-1 border-b border-b-primary-gray-100 pb-6">
        <Typography variant="title1">기존 작성한 응답 확인</Typography>
        <Typography variant="body3" className="text-primary-gray-500">
          {format(new Date(interview.qna.createdAt), 'yyyy.MM.dd')}
        </Typography>
      </div>
      <div className="flex flex-col gap-10 pb-10 pt-6">
        {interview.qna.content
          .filter((item) => !item.added)
          .map((item, index) => (
            <div key={index} className="flex flex-col gap-3">
              <div className="flex flex-row items-start">
                <Typography variant="title2" className="text-primary-orange-800">
                  Q{index + 1}.&nbsp;
                </Typography>
                <Typography variant="title2">{item.question}</Typography>
              </div>
              <div className="rounded-lg border border-primary-gray-200 p-4">
                <Typography variant="body2" className="font-medium">
                  {item.answer}
                </Typography>
              </div>
            </div>
          ))}
      </div>
      {/* 추가 질문이 있는 경우에만 표시 */}
      {interview.qna.content.some((item) => item.added && item.answer) && (
        <div className="flex flex-col gap-3 border-t border-t-primary-gray-200 pb-10 pt-6">
          <Typography variant="title1">추가 질문</Typography>
          {interview.qna.content
            .filter((item) => item.added)
            .map((item, index) => (
              <div key={index} className="flex flex-col gap-3">
                <div className="flex flex-row items-start">
                  <Typography variant="title2" className="text-primary-orange-800">
                    Q{index + 1}.&nbsp;
                  </Typography>
                  <Typography variant="title2">{item.question}</Typography>
                </div>
                <div className="rounded-lg border border-primary-gray-200 p-4">
                  <Typography variant="body2" className="font-medium">
                    {item.answer || '-'}
                  </Typography>
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
}
